import React, { useEffect, useState } from "react";
import "./PWCascader.scss";
import { Cascader } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
const { SHOW_CHILD } = Cascader;

// interface Option {
//   value?: string | number | any | null;
//   level?: number;
//   label: React.ReactNode;
//   code?: number;
//   children?: Option[];
//   isLeaf?: boolean;
//   loading?: boolean;
// }

const PWCascader = (props: any) => {
  const {
    defaultOptions = [
      // {
      //   type: 61,
      //   typeName: 'Country-wise',
      //   subType: 232,
      //   subTypeName: 'India (Calculated Average GHGP India)',
      // },
      // {
      //   type: 63,
      //   typeName: 'GHG Protocol',
      //   subType: 239,
      //   subTypeName: 'India (GHG India)',
      // },
      // {
      //   type: 63,
      //   typeName: 'GHG Protocol',
      //   subType: 240,
      //   subTypeName: 'Singapore (GHG Singapore)',
      // },
    ],
    defaultArray = [],
    onSelectCascade,
    optionsData,
    setContent,
    multiple = false,
    setShowMethod,
  } = props;
  // const getInitOptionsFromDefault = (types: any) => {
  //   let catTypesData = types ? types : [];
  //   let resMap: any = {};
  //   catTypesData.forEach((eachType: any) => {
  //     if (resMap[eachType.type]) {
  //       resMap[eachType.type].children.push({
  //         label: eachType.subTypeName,
  //         value: eachType.subType,
  //       });
  //     } else {
  //       resMap[eachType.type] = {
  //         label: eachType.typeName,
  //         value: eachType.type,
  //         children: [],
  //       };
  //       if (eachType.subType) {
  //         resMap[eachType.type].children.push({
  //           label: eachType.subTypeName,
  //           value: eachType.subType,
  //         });
  //       }
  //     }
  //   });
  //   console.log("getInitOptionsFromDefault", Object.values(resMap));
  //   return Object.values(resMap);
  // };
  const [options, setOptions] = useState<any[]>(defaultOptions);

  useEffect(() => {
    if (optionsData?.length) {
      setOptions(optionsData);
      console.log("setOptions = ", optionsData);
    }
  }, [optionsData]);

  // const getDefaultValueArray = () => {
  //   let catTypesData = defaultOptions ? defaultOptions : [];
  //   console.log(
  //     "getDefaultValueArray",
  //     catTypesData.map((eachType: any) =>
  //       eachType.subType ? [eachType.type, eachType.subType] : [eachType.type]
  //     )
  //   );
  //   return catTypesData.map((eachType: any) =>
  //     eachType.subType ? [eachType.type, eachType.subType] : [eachType.type]
  //   );
  // };
  const onChange = (value: any[], selectedOptions: any[]) => {
    console.log(selectedOptions);
    let sourceTypes;
    if (multiple) {
      sourceTypes = selectedOptions
        .filter((eachType) => eachType?.length)
        .flatMap((eachType) => processTypesFromOptions(eachType));
    } else {
      sourceTypes = processTypesFromOptions(selectedOptions);
    }
    onSelectCascade(sourceTypes);
  };
  const processTypesFromOptions = (eachType: any[]) => {
    //check is array
    if (eachType.length === 2) {
      console.log("eachType[0].children", eachType[0].children);
      console.log("eachType[1].value", eachType[1]);

      let subTypes = eachType[0].children
        ?.filter((eachSubType: any) => eachSubType.value === eachType[1].value)
        .map((eachSubType: any) => {
          console.log("eachSubType", eachSubType);
          return {
            type: eachType[0].value,
            typeName: eachType[0].label,
            subType: eachSubType.value,
            subTypeName: eachSubType.label,
          };
        });
      return subTypes;
    } else {
      return eachType[0].children?.length
        ? eachType[0].children?.map((eachSubType: any) => {
            return {
              type: eachType[0].value,
              typeName: eachType[0].label,
              subType: eachSubType.value,
              subTypeName: eachSubType.label,
            };
          })
        : {
            type: eachType[0].value,
            typeName: eachType[0].label,
          };
    }
  };

  const onDropdownVisibleChange = (event: any) => {
    if (event) {
      setContent();
    }
  };

  return (
    <Cascader
      maxTagCount="responsive"
      className="pw-cascader"
      suffixIcon={<CaretDownOutlined className="!pointer-events-none" />}
      options={options}
      onClear={() => setShowMethod(false)}
      // displayRender={displayRender}
      showCheckedStrategy={SHOW_CHILD}
      onChange={onChange}
      defaultValue={defaultArray}
      onDropdownVisibleChange={onDropdownVisibleChange}
      multiple={multiple}
    />
  );
};
export default PWCascader;
